import { RedoFeatureNotificationCard } from "@redotech/redo-web/arbiter-components/feature-notification/redo-feature-notification-card";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useEffect, useState } from "react";
import { useLocalStorage } from "usehooks-ts";
import * as styles from "./shipment-details-announcement.module.css";
import announcementImage from "./shipment-details-workspace-animation.svg?url";

const announcementEndsAt = Date.parse("2026-10-23T00:00:00-06:00");

export const ShipmentDetailsAnnouncement = memo(
  function ShipmentDetailsAnnouncement({
    userId,
    teamId,
  }: {
    userId: string;
    teamId: string;
  }) {
    const [dismissed, setDismissed] = useLocalStorage(
      `redo.shipment-details-announcement-dismissed.${teamId}.${userId}`,
      false,
    );
    const [now, setNow] = useState(Date.now);
    useEffect(() => {
      const remaining = announcementEndsAt - Date.now();
      if (remaining <= 0) {
        return;
      }
      const updateNow = () => setNow(Date.now());
      const timeout = setTimeout(updateNow, Math.min(remaining, 2_147_483_647));
      document.addEventListener("visibilitychange", updateNow);
      return () => {
        clearTimeout(timeout);
        document.removeEventListener("visibilitychange", updateNow);
      };
    }, [now]);
    if (dismissed || Math.max(now, Date.now()) >= announcementEndsAt) {
      return null;
    }
    const dismiss = () => setDismissed(true);
    return (
      <Flex className={styles.container}>
        <RedoFeatureNotificationCard
          actionText="Got it"
          description="Meet the new fulfillment details view: a full-screen workspace with sections you can rearrange to suit your workflow."
          image={announcementImage}
          onAction={dismiss}
          onDismiss={dismiss}
          title="New fullscreen view"
        />
      </Flex>
    );
  },
);
